import { Link } from 'react-router-dom';

export interface AssessmentCatalogCardProps {
  id: string;
  title: string;
  code?: string;
  type?: string;
  typeLabel?: string;
  status?: string;
  statusLabel?: string;
  versionCount?: number;
  courseCount?: number;
  questionCount?: number;
}

export function AssessmentCatalogCard({
  id,
  title,
  code,
  typeLabel,
  statusLabel,
  versionCount = 1,
  courseCount = 0,
  questionCount = 0,
}: AssessmentCatalogCardProps) {
  const showUrl = `/evaluaciones/${id}`;
  const coursesLabel = courseCount === 1 ? 'curso' : 'cursos';
  const questionsLabel = questionCount === 1 ? 'pregunta' : 'preguntas';

  return (
    <article className="lms-assessment-catalog-card">
      <div className="lms-assessment-catalog-card__head">
        <span className="lms-assessment-catalog-card__type">{typeLabel ?? 'Evaluación'}</span>
        <span className="lms-assessment-catalog-card__status">{statusLabel ?? 'Borrador'}</span>
      </div>

      <h3 className="lms-assessment-catalog-card__title">
        <Link to={showUrl}>{title}</Link>
      </h3>
      <p className="lms-assessment-catalog-card__code">
        {code ?? id.slice(0, 8)} · v{versionCount}
      </p>

      <div className="lms-assessment-catalog-card__footer">
        <div className="lms-assessment-catalog-card__meta">
          <span className="lms-assessment-catalog-card__meta-item" title="Cursos vinculados">
            <span className="material-symbols-outlined" aria-hidden="true">
              school
            </span>
            {courseCount} {coursesLabel}
          </span>
          <span className="lms-assessment-catalog-card__meta-item" title="Número de preguntas">
            <span className="material-symbols-outlined" aria-hidden="true">
              help
            </span>
            {questionCount} {questionsLabel}
          </span>
        </div>
        <Link to={showUrl} className="lms-assessment-catalog-card__view" title="Ver detalle" aria-label={`Ver ${title}`}>
          <span className="material-symbols-outlined" aria-hidden="true">
            visibility
          </span>
        </Link>
      </div>
    </article>
  );
}
